(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rc-review-rotator')) {
    customElements.define('rc-review-rotator', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.rc-slide')];
        this.i = 0;
        this.counter = this.querySelector('[data-current]');
        this.querySelectorAll('.rc-arrow').forEach(b => b.addEventListener('click', () => { this.go(this.i + Number(b.dataset.dir)); this.restart(); }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.restart());
        this.addEventListener('focusin', () => this.stop());
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.restart();
      }
      disconnectedCallback() { this.stop(); }
      go(n) {
        const len = this.slides.length; if (!len) return;
        this.slides[this.i].classList.remove('is-active'); this.slides[this.i].setAttribute('aria-hidden', 'true');
        this.i = (n + len) % len;
        this.slides[this.i].classList.add('is-active'); this.slides[this.i].setAttribute('aria-hidden', 'false');
        if (this.counter) this.counter.textContent = this.i + 1;
      }
      stop() { clearInterval(this.t); }
      restart() { this.stop(); if (this.reduce || this.slides.length < 2) return; this.t = setInterval(() => this.go(this.i + 1), Number(this.dataset.interval) || 7000); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
